import styled from 'styled-components';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import {ModalBody} from '../modal-sections/ModalBody';
import {Icon} from '../../elements/Icon/Icon';
import {ModalHeader} from '../modal-sections/ModalHeader';
import {ModalContainer} from '../modal-sections/ModalContainer';
import {ModalTitle} from '../modal-sections/ModalTitle';

import _ from 'lodash';
import {ModalCloseBtn} from '../modal-sections/ModalCloseBtn';
import {ModalFooter} from '../modal-sections/ModalFooter';
import {useModalContext} from '../../../modalContext';

const Sidebar = ({children, size, title, show, onHide, footer}) => {
    const [closing, setClosing] = useState(false);

    const {isInModal} = useModalContext();

    if (!show) return null;

    const handleClick = () => {
        if (!closing) {
            setClosing(true);
            _.delay(() => {
                onHide();
                setClosing(false);
            }, 800);
        }
    };

    const sidebarContent = (
        <ModalContainer size={size} closing={closing} isPopupModal={isInModal}>
            <SidebarBox show={show} closing={closing} isPopupModal={isInModal} className={isInModal ? 'target' : ''}>
                <ModalContent>
                    <ModalHeader>
                        {title && <ModalTitle>{title}</ModalTitle>}
                        <ModalCloseBtn size="sm" link onClick={handleClick} type="button">
                            <Icon name="close" />
                        </ModalCloseBtn>
                    </ModalHeader>
                    <ModalBody>{children}</ModalBody>
                    {footer && <ModalFooter>{footer}</ModalFooter>}
                </ModalContent>
            </SidebarBox>
        </ModalContainer>
    );

    return isInModal ? (
        <div>{sidebarContent}</div>
    ) : (
        ReactDOM.createPortal(sidebarContent, document.getElementById('portal'))
    );
};

const ModalContent = styled.div`
    height: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    ${ModalBody} {
        height: 100%;
        position: relative;
        flex-grow: 1;
    }
    ${ModalFooter} {
        background: var(--container-background-color-100);
        box-shadow: none;
        &::before {
            display: none;
        }
    }
`;

const SidebarBox = styled.div`
    pointer-events: fill;
    height: 100vh;
    width: var(--sidebar-width);
    position: fixed;
    right: 0px;
    box-shadow: var(--container-shadow-color-500);

    background: var(--container-background-color-100);
    ${ModalHeader} {
        background: none;
        box-shadow: none;
        padding-bottom: 0;
    }

    ${ModalBody} {
        height: 100%;
        position: relative;
        background: none;
    }

    ${({isPopupModal}) => {
        if (isPopupModal)
            return `
            position: absolute;
             z-index: 9990;
            height: 100%;
            top: 0;

        ${ModalBody} {
            overflow: auto!important;
        }
        `;
    }}

    transition: right var(--sidebar-animation-speed) ease-in-out;

    ${({show, closing}) => {
        if (show && !closing)
            return `
                right: 0px;
            `;
        else
            return `
                right: calc(0px - var(--dialog-width) - 30px);
            `;
    }}
`;

Sidebar.Box = SidebarBox;
Sidebar.Wrapper = ModalContainer;
Sidebar.Title = ModalTitle;
Sidebar.Header = ModalHeader;
Sidebar.Body = ModalBody;
Sidebar.Footer = ModalFooter;
Sidebar.Content = ModalContent;

export {Sidebar, SidebarBox, ModalContent, ModalContainer, ModalTitle, ModalBody, ModalHeader};
